import fetch from './fetch'

import { LoginRequest, SessionPayload, ForgotRequest, TwoFactRequest } from '../actions'
import { storageGetItem } from '../components/common/Cookie'

export const getSession = async (): Promise<SessionPayload> => {
  return await fetch('/session')
}

export const login = async ({ email, password }: LoginRequest): Promise<{
  agent_admin?: boolean,
  success: boolean,
  loginData: any,
}> => {
  return await fetch('/session', {
    body: {
      email,
      password,
    },
  })
}

export const twofactlogin = async ({ two_fact_key }: TwoFactRequest): Promise<{
  agent_admin?: boolean,
  success: boolean,
}> => {
  return await fetch('/session/two_fact_auth', {
    body: {
      two_fact_key,
      login_data: storageGetItem('loginData'),
    },
  })
}

export const logout = async (): Promise<string> => {
  return await fetch('/session', {
    method: 'DELETE',
    raw: true,
  })
}

/**
 * fetch API endpoint to trigger the password change on the server
 * @param  {email}:{ForgotRequest} [Email address passed by payload on action]
 */
export const forgot = async ({ email }: ForgotRequest): Promise<string> => {
  return await fetch('/user/forgot_password', {
    method: 'POST',
    body: {
      'email' : email,
    },
  })
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/api/index.ts